import styled from "styled-components";
import { colors, typography } from "@streeteasy/design-system";
import actionElements from "@streeteasy/design-system/constants/actionElements";
import TextAction, {
  textActionTypography
} from "@streeteasy/design-system/text-action";

import { largeScreen } from "src/shared/constants/screenSizes";

export const Wrapper = styled.div`
  flex: 0 0 228px;
  margin: 0 24px 0 0;
  padding-bottom: 52px;

  &:nth-child(4) {
    margin-right: 0;
  }

  @media screen and (max-width: ${largeScreen}px) {
    flex: 0 0 198px;
    margin-right: 0;
    padding-bottom: 25px;
  }
`;

export const TriggerNode = styled(TextAction).attrs({
  type: "button",
  element: actionElements.button,
  underlined: false,
  typography: textActionTypography.CAPTION
})`
  color: ${colors.WHITE};
  line-height: 24px;
  text-align: left;
  white-space: nowrap;
  width: auto;

  &:focus {
    outline: 1px solid ${colors.WHITE};
    outline-offset: 2px;
  }
`;

export const ExpandedSection = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  @media screen and (max-width: ${largeScreen}px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const ItemWrapper = styled.li`
  color: ${colors.WHITE};
  flex: 1 0 100%;
  line-height: 23px;

  @media screen and (max-width: ${largeScreen}px) {
    flex-basis: 50%;
    max-width: 109px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Link = styled(TextAction).attrs({
  typography: textActionTypography.CAPTION,
  underlined: false,
  color: colors.WHITE
})`
  &,
  &:active,
  &:hover {
    background: none;
    color: ${colors.WHITE};
  }
`;

export const Header = styled(typography.Caps).attrs({
  as: "a"
})`
  color: ${colors.WHITE};
  letter-spacing: 0.05em;
  line-height: 24px;
`;
